export const COURSE_CAMPAIGN = '/course/course-campaign'
